'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _buttonLocal = require('../button/button.local.css');

var _buttonLocal2 = _interopRequireDefault(_buttonLocal);

var _buttonGroupLocal = require('./button-group.local.css');

var _buttonGroupLocal2 = _interopRequireDefault(_buttonGroupLocal);

var _button = require('../button');

var _button2 = _interopRequireDefault(_button);

var _popupMenu = require('../popup-menu/popup-menu');

var _popupMenu2 = _interopRequireDefault(_popupMenu);

var _popupMenuItem = require('../popup-menu/popup-menu-item');

var _popupMenuItem2 = _interopRequireDefault(_popupMenuItem);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * Group a series of buttons together on a single line
 */


var ButtonGroup = function (_Component) {
  _inherits(ButtonGroup, _Component);

  function ButtonGroup(props) {
    _classCallCheck(this, ButtonGroup);

    var _this = _possibleConstructorReturn(this, (ButtonGroup.__proto__ || Object.getPrototypeOf(ButtonGroup)).call(this, props));

    _this.state = {
      isPopupMenuVisible: false
    };
    return _this;
  }

  _createClass(ButtonGroup, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          buttons = _props.buttons,
          popupItems = _props.popupItems,
          _onClick = _props.onClick,
          activeButton = _props.activeButton,
          fullWidth = _props.fullWidth;
      var buttonElements = buttons.map(function (button) {
        var _classNames;

        return _react2.default.createElement(_button2.default, {
          color: 'light',
          theme: 'boxyLight',
          className: (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, _buttonGroupLocal2.default.button, true), _defineProperty(_classNames, _buttonLocal2.default.active, button.value === activeButton), _classNames)),
          icon: button.icon,
          key: button.value,
          onClick: function onClick() {
            _onClick(button.value);
          }
        }, button.label);
      });
      var popupMenuElement = popupItems && popupItems.length ? _react2.default.createElement(_popupMenu2.default, {
        align: 'left',
        theme: 'light',
        visible: this.state.isPopupMenuVisible,
        onClick: function onClick() {
          _this2.setState({
            isPopupMenuVisible: true
          });
        },
        hide: function hide() {
          _this2.setState({
            isPopupMenuVisible: false
          });
        },
        customToggleComponent: _react2.default.createElement(_button2.default, {
          className: _buttonGroupLocal2.default.opener,
          color: 'light',
          theme: 'boxyLight',
          icon: 'caret'
        })
      }, popupItems.map(function (popupItem) {
        var label = popupItem.label,
            value = popupItem.value,
            icon = popupItem.icon;
        return _react2.default.createElement(_popupMenuItem2.default, {
          key: value,
          icon: icon,
          id: value,
          onClick: function onClick() {
            _onClick(value);
          },
          iconClassName: _this2.props.direction === 'rtl' ? _buttonGroupLocal2.default.rtlPopupItemIcon : undefined
        }, label);
      })) : null;
      var props = {
        className: (0, _classnames2.default)(_buttonGroupLocal2.default.wrapper, fullWidth && _buttonGroupLocal2.default.fullWidth),
        dir: this.props.direction === 'rtl' ? 'rtl' : undefined
      };
      return _react2.default.createElement('div', props, _react2.default.createElement('div', {
        className: _buttonGroupLocal2.default.buttons
      }, buttonElements), popupMenuElement && popupMenuElement);
    }
  }]);

  return ButtonGroup;
}(_react.Component);

ButtonGroup.displayName = 'ButtonGroup';

var option = _propTypes2.default.shape({
  label: _propTypes2.default.string,
  value: _propTypes2.default.string.isRequired,
  icon: _propTypes2.default.string
}).isRequired;

ButtonGroup.defaultProps = {
  direction: 'ltr'
};
ButtonGroup.propTypes = {
  /**
   * Text direction. One of 'rtl', 'ltr'.
   */
  direction: _propTypes2.default.oneOf(['rtl', 'ltr']),

  /**
   * Whether it should expand to the width of the parent container.
   */
  fullWidth: _propTypes2.default.bool,

  /**
   * Indicates the active button from `props.buttons`. It cannot be from `props.popupItems`.
   */
  activeButton: _propTypes2.default.string.isRequired,
  onClick: _propTypes2.default.func.isRequired,
  buttons: _propTypes2.default.arrayOf(option).isRequired,

  /**
   * Items to be rendered in the popup menu next to the buttons
   */
  popupItems: _propTypes2.default.arrayOf(option)
};
exports.default = ButtonGroup;